const handledPreloadErrors = new WeakSet<object>();

function isObjectLike(value: unknown): value is object {
  return (typeof value === "object" && value !== null) || typeof value === "function";
}

export function markPreloadErrorHandled(error: unknown): void {
  if (isObjectLike(error)) {
    handledPreloadErrors.add(error);
  }
}

export function wasPreloadErrorHandled(error: unknown): boolean {
  return isObjectLike(error) && handledPreloadErrors.has(error);
}
